import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService {
  constructor( public router: Router, private http: HttpClient) {
  }
//step 1
  // user login 
  sendOtp(authid: string) {
    return this.http.post(`${environment.url}/users/u1/user/sendOtp`, { authid });
  }
  verifyOTP(authid: string, otp: string) {
    return this.http.post(`${environment.url}/users/u1/user/verifyOtp`, { authid, otp });
  }
  forgotPassword(email: string,changePassword:boolean) {
    return this.http.post(`${environment.url}/users/u1/user/forgot-password`, { email,changePassword });
  }
  resetPassword(payload: any, token: string) {
    return this.http.post(`${environment.url}/users/u1/user/reset-password/${token}`, payload);
  }
  login(authid: string, password: string) {
    return this.http.post(`${environment.url}/users/u1/user/loginUser`, { authid, password });
  }
// step 2

  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }
  createUser(formData: any): Observable<any> {
    return this.http.post(`${environment.url}/users/create`, formData);
  }
  updateUser(formData: any): Observable<any> {
    return this.http.put(`${environment.url}/users/updateById`, formData);
  }
  listUsers(): Observable<any> {
    return this.http.get(`${environment.url}/users/getlist`);
  }

  getWhiteListIps(query: any) {
    return this.http.get(`${environment.url}/users/getWhiteListIps`, { params: query });
  }
  addWhiteListIps(query: any) {
    return this.http.put(`${environment.url}/users/addWhiteListIps?userId=${query.userId}&ip=${query.ip}`, {});
  }
  updateWhiteListIps(id: any, data: any) {
    return this.http.put(`${environment.url}/users/updateWhiteListIps?userId=${id}`, data);
  }
  getWhiteListAccounts(query: any) {
    return this.http.get(`${environment.url}/users/getWhiteListAccounts`, { params: query });
  }
  addWhiteListAccounts(query: any) {
    return this.http.put(`${environment.url}/users/addWhiteListAccounts?userId=${query.userId}&assignedAccount=${query.assignedAccount}`, {});
  }
  updateWhiteListAccounts(id: any, data: any) {
    return this.http.put(`${environment.url}/users/updateWhiteListAccounts?userId=${id}`, data);
  }
  updateAccountStatus(id: any, data: any) {
    return this.http.put(`${environment.url}/users/updateAccountStatus?userId=${id}`, data);
  }
  updatePassword(data: any, id: any) {
    return this.http.put(`${environment.url}/users/${id}`, data);
  }
  consumer_key(query: any) {
    return this.http.post(`${environment.url}/users/consumer_key?userId=${query.userId}&type=${query.type}&status=${query.status}`, {});
  }
  consumer_secret(query: any) {
    return this.http.post(`${environment.url}/users/consumer_secret?userId=${query.userId}&type=${query.type}&status=${query.status}`, {});
  }
  updateStatus(query: any) {
    return this.http.put(`${environment.url}/users/updateStatus?id=${query.userId}`, query.frmData);
  }
  getCallbackUrls(query: any) {
    return this.http.get(`${environment.url}/users/getCallbackUrls`, { params: query });
  }
  addCallbackListUrls(query: any) {
    return this.http.put(`${environment.url}/users/addCallbackListUrls?userId=${query.userId}&key=${query.key}&value=${query.value}`, {});
  }
  updateCallbackListUrls(id: any, data: any) {
    return this.http.put(`${environment.url}/users/updateCallbackListUrls?userId=${id}`, data);
  }
  updateYbAccounts(id: any, data: any) {
    return this.http.put(`${environment.url}/users/updateYbAccounts?userId=${id}`, data);
  }
  ybAssignAccount(query: any) {
    return this.http.get(`${environment.url}/users/ybAccount/getList?is_active=${query.is_active}&page=${query.page}&limit=${query.limit}`, {});
  }
  ybAssignAccountById(id: any) {
    return this.http.get(`${environment.url}/users/ybAccount/getDataById?id=${id}`, {});
  }
  updateAmountLimit(id: any, data: any) {
    return this.http.put(`${environment.url}/users/updateAmountLimit?userId=${id}`, data);
  }
  yesBankStatement(data: any) {
    return this.http.post(`${environment.url}/transactions/payout/inquiry`, data);
  }
  logout() {
    this.router.navigate(['/login']);
  }
  isAuthenticated() {
    return true;
  }
}
